// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"6fd501dd","160":"e258836b","208":"58027a0a","293":"47b1db26","516":"8c7dd791","519":"2d554b08","917":"1b743f88","946":"f5d51190"}[chunkId] + ".chunk.js";
};